import { TableDefine } from '@/libs/tableHelper/type'
import { Village } from '@/api/village/Village'

// 数据表格的列定义
export default function getTableDefine (view: any): TableDefine<Village> {
  const tableCols = [
    {
      title: '村庄名称',
      key: 'name',
      width: 300
    },
    {
      title: '省',
      key: 'province'
    },
    {
      title: '城市',
      key: 'city'
    },
    {
      title: '区/县',
      key: 'area'
    },
    {
      title: '地址',
      key: 'address'
    },
    {
      title: '修改时间',
      type: {
        module: 'time',
        format: 'yyyy-MM-DD'
      },
      key: 'updateTime',
      width: 200
    },
    {
      title: '创建时间',
      type: {
        module: 'time',
        format: 'yyyy-MM-DD'
      },
      key: 'createTime',
      width: 200
    }
  ]

  const actions: any = [
    {
      name: 'view',
      title: '详情',
      onClick: (dataItem: Village) => {
        view.onViewItem(dataItem)
      }
    },
    {
      name: 'edit',
      title: '编辑',
      onClick: (dataItem: Village) => {
        view.onEditItem(dataItem)
      }
    }
  ]

  return {
    tableCols,
    actions
  }
}
